import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useProduct} from "../hooks/useProduct.ts";
import {Product, ProductStatus} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useProduct();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                status: ProductStatus.Draft,
            } as Product}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
